import { Checkbox } from 'primereact/checkbox'
import React from 'react'

const CheckboxCom = ({ id, name, onChange, checked, disabled }) => {
  return (
    <Checkbox
      id={id}
      name={name}
      onChange={(e) =>
        onChange({ target: { value: e.checked, name: e.target.name } })
      }
      checked={checked}
      disabled={disabled}
      style={{ pointerEvents: disabled ? 'none' : undefined }}
    />
  )
}

export default CheckboxCom
